import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreBoolean } from '../../ParseHelper';
import { FilteredKeys } from '../../../Utility/Types';

export default class BoolProperty<
    TPlayerStateKey extends FilteredKeys<IPlayerState, boolean>,
    TPlayerDataKey extends FilteredKeys<IPlayerData, number>
>
    implements PlayerProperty<TPlayerStateKey, TPlayerDataKey>
{
    private readonly playerStateKey: TPlayerStateKey;
    private readonly playerDataKey: TPlayerDataKey;

    constructor(
        playerStateKey: TPlayerStateKey,
        playerDataKey: TPlayerDataKey,
    ) {
        this.playerStateKey = playerStateKey;
        this.playerDataKey = playerDataKey;
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerEndpointData[this.playerDataKey] !== this.save(playerStateData)[this.playerDataKey];
    }

    public restore(playerEndpointData: IPlayerData): Restore<TPlayerStateKey> {
        return restoreBoolean(playerEndpointData[this.playerDataKey], false);
    }

    public save(playerStateData: IPlayerState): Save<TPlayerDataKey> {
        return {
            [this.playerDataKey]: playerStateData[this.playerStateKey] ? 1 : 0,
        } as Pick<IPlayerData, TPlayerDataKey>;
    }
}
